
import {ProductVehicle, Vehicle} from "product/productDomain";
import {observable} from "mobx";
import { entityConfig, DomainAncestor, fieldInfo } from 'core/common/domain/DomainAncestor';
import { LovItem } from 'core/metamodel/mdEntity';
import { ID } from 'core/metamodel/metaConstant';



export enum SUBSTYPE {
  MONTHLYPAYMENT = 'MONTHLYPAYMENT',
  UPFRONTPAYMENT = 'UPFRONTPAYMENT',
  PREPAID = 'PREPAID',
  RECURRING = 'RECURRING',
}

@entityConfig()
export class BrimMessage extends DomainAncestor {
  @observable messageId?: number;
  @observable status? : LovItem;
  @observable statusDescription?: string;
  @observable businessArea?: string;
  @observable countryCode?:string;
  @observable startDate?: string|Date;
  @observable endDate?: string|Date;
  @observable statusChangeDate?: string|Date;
  @observable customerPartyId? :string;
  @observable vin? :string ;
  @observable duration?: number;
  @observable productName?: string;
  @observable productNumber?: string;
  @observable productStatus?: string;
  @observable subscriptionType?: string;
  @observable salesType?: string;
  @observable registrationNumber?:string;
  @observable externalOrderNumber?:string;
  @observable subscriptionNumber?:string;
  @observable subscriptionId?:string;
  @observable transactionType?:string;
  @observable notificationDate?:string|Date;
  @observable party?:LovItem;
  @observable @fieldInfo(Vehicle) vehicle?: Vehicle;
  @observable product?:LovItem;


  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.messageId;
  }

  public setId(id: ID): void {
    this.messageId = id as any;
  }

}

@entityConfig()
export class ImportEntryBrimMessage extends DomainAncestor {
  @observable @fieldInfo(BrimMessage) brimMessage?: BrimMessage;
  @observable @fieldInfo(ProductVehicle) futureProductVehicle? : ProductVehicle;
  @observable substype? : LovItem;
  @observable productStatus?: LovItem;

  constructor(json: any) {
    super(json);
  }
}


// WEBPACK FOOTER //
// ./src/core/dataimport/dataImportDomain.ts